module.exports = __webpack_public_path__ + "static/img/bossTou.320ba5bb.png";